import api from '../config/api';
import { getApiData, parseApiError } from './apiUtils';

const withSolicitante = (payload, solicitanteId) => ({
  ...payload,
  solicitante_id: solicitanteId,
});

export const fetchAdminRoles = (solicitanteId) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/admin_roles_listar.php', withSolicitante({}, solicitanteId))
    .then((response) => getApiData(response, 'No se pudieron cargar los roles.'))
    .then((data) => data.roles || [])
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const fetchAdminUsers = (solicitanteId) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/admin_usuarios_listar.php', withSolicitante({}, solicitanteId))
    .then((response) => getApiData(response, 'No se pudieron cargar los usuarios.'))
    .then((data) => data.usuarios || [])
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const saveAdminUser = (solicitanteId, payload) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/admin_usuario_guardar.php', withSolicitante(payload, solicitanteId))
    .then((response) => getApiData(response, 'No se pudo guardar el usuario.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const fetchInventoryServices = (solicitanteId) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/inventario_listar.php', withSolicitante({}, solicitanteId))
    .then((response) => getApiData(response, 'No se pudo cargar el inventario.'))
    .then((data) => data.servicios || [])
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const saveInventoryService = (solicitanteId, payload) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/inventario_guardar.php', withSolicitante(payload, solicitanteId))
    .then((response) => getApiData(response, 'No se pudo guardar el servicio.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};

const fetchSpecialistSheets = (solicitanteId, todos) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post(
      '/admin_especialistas_preaprobar.php',
      withSolicitante(
        {
          accion: 'listar',
          todos: todos ? 1 : 0,
          incluir_todas: todos ? 1 : 0,
        },
        solicitanteId
      )
    )
    .then((response) => getApiData(response, 'No se pudieron cargar las planillas.'))
    .then((data) => data.especialistas || [])
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const fetchPendingSpecialists = (solicitanteId) => fetchSpecialistSheets(solicitanteId, false);

export const fetchAllSpecialists = (solicitanteId) => fetchSpecialistSheets(solicitanteId, true);

export const fetchSpecialistPlanilla = (solicitanteId, planillaId) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  if (!planillaId) {
    return Promise.reject(new Error('Seleccione un especialista de la lista.'));
  }

  return api
    .post(
      '/admin_especialistas_preaprobar.php',
      withSolicitante({ accion: 'detalle', id: planillaId }, solicitanteId)
    )
    .then((response) => getApiData(response, 'No se pudo abrir la planilla.'))
    .then((data) => data.planilla || null)
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const saveSpecialistPlanilla = (solicitanteId, planilla) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  if (!planilla || !planilla.id) {
    return Promise.reject(new Error('Seleccione un especialista de la lista.'));
  }

  return api
    .post(
      '/admin_especialistas_preaprobar.php',
      withSolicitante(
        { accion: 'guardar_miperfil', id: planilla.id, secciones: planilla.secciones },
        solicitanteId
      )
    )
    .then((response) => getApiData(response, 'No se pudo guardar la planilla.'))
    .then((data) => data.planilla || null)
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const preapproveSpecialist = (solicitanteId, planillaId) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post(
      '/admin_especialistas_preaprobar.php',
      withSolicitante({ accion: 'preaprobar', id: planillaId }, solicitanteId)
    )
    .then((response) => {
      const data = getApiData(response, 'No se pudo preaprobar el especialista.');
      return {
        ...data,
        message: (response.data && response.data.message) || '',
      };
    })
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const fetchWorkSchedule = (solicitanteId, usuarioId) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/nomina_horario.php', withSolicitante({ accion: 'obtener', usuario_id: usuarioId }, solicitanteId))
    .then((response) => getApiData(response, 'No se pudo cargar el horario.'))
    .then((data) => data.horario)
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const saveWorkSchedule = (solicitanteId, usuarioId, horario) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post(
      '/nomina_horario.php',
      withSolicitante({ accion: 'guardar', usuario_id: usuarioId, horario }, solicitanteId)
    )
    .then((response) => getApiData(response, 'No se pudo guardar el horario.'))
    .then((data) => data.horario)
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const fetchPayrollData = (solicitanteId, usuarioId) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/nomina_datos.php', withSolicitante({ accion: 'obtener', usuario_id: usuarioId }, solicitanteId))
    .then((response) => getApiData(response, 'No se pudieron cargar los datos administrativos.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const savePayrollData = (solicitanteId, usuarioId, datos) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post(
      '/nomina_datos.php',
      withSolicitante({ accion: 'guardar', usuario_id: usuarioId, ...datos }, solicitanteId)
    )
    .then((response) => getApiData(response, 'No se pudieron guardar los datos administrativos.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const setPayrollActive = (solicitanteId, usuarioId, id, desactivada) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post(
      '/nomina_datos.php',
      withSolicitante({ accion: 'desactivar', usuario_id: usuarioId, id, desactivada }, solicitanteId)
    )
    .then((response) => getApiData(response, 'No se pudo actualizar la nómina.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const fetchStudyAmounts = (solicitanteId) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/configuracion_montos.php', withSolicitante({ accion: 'listar' }, solicitanteId))
    .then((response) => getApiData(response, 'No se pudieron cargar los montos.'))
    .then((data) => data.montos || [])
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const saveStudyAmount = (solicitanteId, payload) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/configuracion_montos.php', withSolicitante({ accion: 'guardar', ...payload }, solicitanteId))
    .then((response) => getApiData(response, 'No se pudo guardar el monto.'))
    .then((data) => data.montos || [])
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const deleteStudyAmount = (solicitanteId, id) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/configuracion_montos.php', withSolicitante({ accion: 'eliminar', id }, solicitanteId))
    .then((response) => getApiData(response, 'No se pudo eliminar el monto.'))
    .then((data) => data.montos || [])
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const fetchPayrollDiscounts = (solicitanteId) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/nomina_descuentos.php', withSolicitante({ accion: 'listar' }, solicitanteId))
    .then((response) => getApiData(response, 'No se pudieron cargar los tipos de descuento.'))
    .then((data) => data.descuentos || [])
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const savePayrollDiscount = (solicitanteId, descripcion, descuenta) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/nomina_descuentos.php', withSolicitante({ accion: 'guardar', descripcion, descuenta }, solicitanteId))
    .then((response) => getApiData(response, 'No se pudo agregar el tipo de descuento.'))
    .then((data) => data.descuentos || [])
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const setPayrollDiscountDeduction = (solicitanteId, id, descuenta) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/nomina_descuentos.php', withSolicitante({ accion: 'marcar', id, descuenta }, solicitanteId))
    .then((response) => getApiData(response, 'No se pudo actualizar si descuenta.'))
    .then((data) => data.descuentos || [])
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const fetchPayrollDiscountEntries = (solicitanteId, usuarioId) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/nomina_descuento_honorarios.php', withSolicitante({ accion: 'listar', usuario_id: usuarioId }, solicitanteId))
    .then((response) => getApiData(response, 'No se pudieron consultar los descuentos.'))
    .then((data) => data.registros || [])
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const savePayrollDiscountEntry = (solicitanteId, payload) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/nomina_descuento_honorarios.php', withSolicitante({ accion: 'guardar', ...payload }, solicitanteId))
    .then((response) => {
      const data = getApiData(response, 'No se pudo guardar el descuento.');
      return {
        registros: data.registros || [],
        message: (response.data && response.data.message) || 'Descuento guardado.',
      };
    })
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const deletePayrollDiscountEntry = (solicitanteId, usuarioId, id) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post(
      '/nomina_descuento_honorarios.php',
      withSolicitante({ accion: 'eliminar', usuario_id: usuarioId, id }, solicitanteId)
    )
    .then((response) => getApiData(response, 'No se pudo eliminar el descuento.'))
    .then((data) => data.registros || [])
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const downloadPayrollDiscountReport = (solicitanteId, periodo) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post(
      '/nomina_descuento_honorarios.php',
      withSolicitante({ accion: 'reporte', ...periodo }, solicitanteId),
      { responseType: 'arraybuffer' }
    )
    .then((response) => {
      const bytes = new Uint8Array(response.data);
      const inicio = String.fromCharCode(bytes[0] || 0, bytes[1] || 0, bytes[2] || 0, bytes[3] || 0);

      if (inicio !== '%PDF') {
        const texto = new TextDecoder('utf-8').decode(bytes);
        let mensaje = 'No se pudo generar el reporte.';

        try {
          const json = JSON.parse(texto);
          if (json && json.message) {
            mensaje = json.message;
          }
        } catch (parseError) {
          mensaje = 'No se pudo generar el reporte.';
        }

        throw new Error(mensaje);
      }

      const blob = new Blob([response.data], { type: 'application/pdf' });
      window.open(URL.createObjectURL(blob));
    })
    .catch((error) => {
      const cuerpo = error && error.response ? error.response.data : null;

      if (cuerpo instanceof ArrayBuffer) {
        const texto = new TextDecoder('utf-8').decode(new Uint8Array(cuerpo));

        try {
          const json = JSON.parse(texto);
          if (json && json.message) {
            throw new Error(json.message);
          }
        } catch (parseError) {
          if (parseError && parseError.message && parseError.message !== texto) {
            throw parseError;
          }
        }
      }

      if (error instanceof Error && error.message && error.response === undefined) {
        throw error;
      }

      throw parseApiError(error);
    });
};

export const fetchPayrollConsult = (solicitanteId, periodo) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/nomina_consultar.php', withSolicitante({ accion: 'listar', ...periodo }, solicitanteId))
    .then((response) => getApiData(response, 'No se pudo consultar la nómina.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const updatePayrollConsult = (solicitanteId, periodo, filas) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post(
      '/nomina_consultar.php',
      withSolicitante({ accion: 'actualizar', ...periodo, filas }, solicitanteId)
    )
    .then((response) => getApiData(response, 'No se pudo actualizar la nómina.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const deletePayrollRow = (solicitanteId, periodo, id) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post(
      '/nomina_consultar.php',
      withSolicitante({ accion: 'eliminar', ...periodo, id }, solicitanteId)
    )
    .then((response) => getApiData(response, 'No se pudo eliminar la fila.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const deletePayrollPeriod = (solicitanteId, periodo, ids) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post(
      '/nomina_consultar.php',
      withSolicitante({ accion: 'eliminar_quincena', ...periodo, ids }, solicitanteId)
    )
    .then((response) => getApiData(response, 'No se pudo eliminar la quincena.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const generateStudyPayroll = (solicitanteId, periodo) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/nomina_estudios.php', withSolicitante({ accion: 'generar', ...periodo }, solicitanteId))
    .then((response) => getApiData(response, 'No se pudo generar la nómina por estudios.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const createPayroll = (solicitanteId, periodo) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/nomina_crear.php', withSolicitante({ accion: 'crear', ...periodo }, solicitanteId))
    .then((response) => getApiData(response, 'No se pudo crear la nómina.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const fetchPayrollCloses = (solicitanteId) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/nomina_cierre_quincena.php', withSolicitante({ accion: 'listar' }, solicitanteId))
    .then((response) => getApiData(response, 'No se pudieron cargar los cierres.'))
    .then((data) => data.cierres || [])
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const savePayrollClose = (solicitanteId, periodo) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/nomina_cierre_quincena.php', withSolicitante({ accion: 'guardar', ...periodo }, solicitanteId))
    .then((response) => getApiData(response, 'No se pudo cerrar la quincena.'))
    .then((data) => data.cierres || [])
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const deletePayrollClose = (solicitanteId, id) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/nomina_cierre_quincena.php', withSolicitante({ accion: 'eliminar', id }, solicitanteId))
    .then((response) => getApiData(response, 'No se pudo abrir la quincena.'))
    .then((data) => data.cierres || [])
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const deletePayrollDiscount = (solicitanteId, id) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  return api
    .post('/nomina_descuentos.php', withSolicitante({ accion: 'eliminar', id }, solicitanteId))
    .then((response) => getApiData(response, 'No se pudo eliminar el tipo de descuento.'))
    .then((data) => data.descuentos || [])
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const unlinkAdminSpecialistTerapias = (solicitanteId, usuarioId) => {
  if (!solicitanteId) {
    return Promise.reject(new Error('Sesión no válida.'));
  }

  if (!usuarioId) {
    return Promise.reject(new Error('Usuario no válido.'));
  }

  return api
    .post(
      '/especialista_verificar_terapias.php',
      withSolicitante(
        {
          usuario_id: usuarioId,
          accion: 'desvincular',
        },
        solicitanteId
      )
    )
    .then((response) => getApiData(response, 'No se pudo desvincular el especialista.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};
